import moment from "moment";

export const REFILL_DATE_FORMAT = "YYYY-MM-DD";
// The backend accepts up to 10 years (orderValidation.ts)
const MAX_REFILL_DAYS = 3650;

// Whole refill days typed on a bill line (0 when empty / invalid)
export const toRefillDays = (value) =>
  Math.min(MAX_REFILL_DAYS, Math.max(0, parseInt(value, 10) || 0));

// Shortage qty typed on a bill line (0 when empty / invalid)
export const toShortageQty = (value) => Math.max(0, parseFloat(value) || 0);

// The date a billed item is due for refill: the bill date + its refill days
// (YYYY-MM-DD), or null when the item has no refill days
export const getRefillDate = (refillDays, billDate) => {
  const days = toRefillDays(refillDays);
  if (days === 0) return null;
  const billMoment = moment(billDate, REFILL_DATE_FORMAT, true);
  return (billMoment.isValid() ? billMoment : moment())
    .add(days, "days")
    .format(REFILL_DATE_FORMAT);
};
